<template>
  <div class="col-md-12 specification_list">

    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <div class="select">
            <tree-select
                :options="type_list"
                :multiple="false"
                v-model="filter.type"
                :placeholder="translate('specification.type')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <fg-input
                type="text"
                v-model="filter.q"
                :placeholder="translate('specification.search')"
                :clearable="true"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select">
          <div class="select">
            <tree-select
                :options="status_list"
                :multiple="false"
                v-model="filter.status"
                :placeholder="translate('specification.status')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <WrapDatePicker
                type="date"
                :placeholder="translate('specification.date')"
                v-model="filter.date"
                :range="true"
                :confirm="true"
                value_type="YYYY-MM-DD"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select">
          <div class="select">
            <tree-select
                :options="params_list"
                :multiple="true"
                v-model="additional_params"
                :placeholder="translate('specification.additional_params')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="select">
            <tree-select
                :options="client_list"
                :multiple="true"
                v-model="filter.client_ids"
                :placeholder="translate('specification.client')"
                :clearable="true"
                @input="change_input"
            />
          </div>
        </div>

        <div class="form_select"></div>

        <div class="buttons">
          <span
              class="btn btn-warning btn-fill"
              @click.prevent="reset_filter"
          >
            <b>{{ translate('filter.reset') }}</b>
          </span>
          <span
              v-if="$store.getters.getPermissions.permissionGod === true"
              class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
              @click.prevent="add_specification"
          >
            <b>{{ translate('specification.to_add') }}</b>
          </span>
        </div>
      </div>
    </div>

    <div class="response_table">
<!--      <div class="summary card" v-if="summary.length > 0">-->
<!--        <p v-for="(sum, key) in summary" :key="key">-->
<!--          <span>{{ translate("client_order.summary." + sum.name) }}:</span>-->
<!--          <span v-html="sum.value" />-->
<!--        </p>-->
<!--      </div>-->
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th
              class="pointer w50"
              @click="change_filter('id')"
              :class="{ selected: filter_type === 'id' }"
              scope="col"
          >
            {{ translate('specification.id') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer w120"
              @click="change_filter('date')"
              :class="{ selected: filter_type === 'date' }"
              scope="col"
          >
            {{ translate('specification.date') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('spec_number')"
              :class="{ selected: filter_type === 'spec_number' }"
              scope="col"
          >
            {{ translate('specification.spec_number') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('client_id')"
              :class="{ selected: filter_type === 'client_id' }"
              scope="col"
          >
            {{ translate('specification.client') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>
          <th
              class="pointer name"
              @click="change_filter('name')"
              :class="{ selected: filter_type === 'name' }"
              scope="col"
          >
            {{ translate('specification.name') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('items_count')"
              :class="{ selected: filter_type === 'items_count' }"
              scope="col"
          >
            {{ translate('specification.positions') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('total_devices')"
              :class="{ selected: filter_type === 'total_devices' }"
              scope="col"
          >
            {{ translate('specification.devices') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('planned_finish_date')"
              :class="{ selected: filter_type === 'planned_finish_date' }"
              scope="col"
          >
            {{ translate('specification.planned_finish_date') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer name"
              @click="change_filter('descr')"
              :class="{ selected: filter_type === 'descr' }"
              scope="col"
          >
            {{ translate('specification.descr') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('user_id')"
              :class="{ selected: filter_type === 'user_id' }"
              scope="col"
          >
            {{ translate('specification.user') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('status')"
              :class="{ selected: filter_type === 'status' }"
              scope="col"
          >
            {{ translate('specification.status') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer w120"
              @click="change_filter('updated_at')"
              :class="{ selected: filter_type === 'updated_at' }"
              scope="col"
          >
            {{ translate('specification.updated_at') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th class="w50" scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <SpecItem
            v-for="(spec,key) in specs_list"
            :key="key"
            :spec_item="spec"
        />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SpecItem from "./Item/Index.vue";
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import AddSpecification from "./Modal/AddSpecification.vue";

export default {
  name: 'SpecificationList',
  components: {
    WrapDatePicker,
    SpecItem
  },
  data() {
    return {
      specification_list: [],
      check_link: true,
      filter: {
        client_ids: [],
        date: [],
        type: null,
        status: null,
        q: "",
        hide_draft: null
      },
      filter_asc: "asc",
      filter_type: "",
      summary: {},
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      additional_params: []
    }
  },

  computed: {
    params_list(){
      return [
        { id: "hide_draft", label: this.translate("specification.hide_draft")}
      ]
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name }
      })
    },

    type_list(){
      return this.$store.getters.getClientOrderSpecs.types.map((type) => {
        return {label: type.descr, id: type.id}
      })
    },

    status_list(){
      return this.$store.getters.getClientOrderSpecs.statuses.map((status) => {
        return {label: status.descr, id: status.id}
      })
    },

    specs_list() {
      let specs_list = [...this.specification_list];
      return specs_list.sort(this.compareNumbers);
    },
  },

  watch: {
    additional_params:{
      deep: true,
      handler(){
        this.params_list.forEach(param => {
          if (this.additional_params.indexOf(param.id) > -1){
            this.filter[param.id] = 1
          }
          else{
            this.filter[param.id] = null
          }
        })
      }
    },
    filter:{
      deep: true,
      handler() {
        if (this.$route.name === 'production_section' && this.$route.params.production_section) {
          let string = '?'
          for (let key in this.filter) {
            if (key === 'date'){
              if(this.filter[key][0] !== null && this.filter[key][1]){
                string += '&' + key + '=' + this.filter[key]
              }
            } else if (key === 'client_ids') {
              if (this.filter[key].length > 0) {
                string += '&' + key + '=' + this.filter[key]
              }
            } else {
              if (this.filter[key] !== null && this.filter[key] !== undefined && this.filter[key] !== "") {
                string += '&' + key + '=' + this.filter[key]
              }
            }
          }
          history.pushState(null, null, this.$route.path + string)
        }
      }
    },
  },
  created() {
    this.check_query()
  },

  destroyed() {
    this.$modal.hide('new_spec_modal')
  },

  methods: {
    add_specification() {
      let t = this.$createElement(AddSpecification, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('new_spec_modal')
            this.check_link = true
          },
          update: () => {
            this.$store.dispatch('clientsListUpdate')
            this.load_specifications()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'new_spec_modal'
      })
    },
    reset_filter() {
      this.filter = {
        client_ids: [],
        date: [],
        type: null,
        status: null,
        q: "",
      }
      this.additional_params = []
    },
    change_input() {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.load_specifications, 300)
    },
    check_query() {
      if (Object.keys(this.$route.query).length > 0) {
        for (let key in this.$route.query) {
          switch (key) {
            case 'type':
            case 'status':
            case 'q':
              this.filter[key] = this.$route.query[key]
              break;
            case 'date':
            case 'client_ids':
              this.filter[key] = this.$route.query[key].split(',')
              break;

            case 'hide_draft':
              this.filter[key] = Number(this.$route.query[key])
              if(!(this.additional_params.indexOf(key) > -1)){
                this.additional_params.push(key)
              }
              break;
          }
        }
      }
      this.change_input()
    },
    load_specifications() {
      let filter = {};
      Object.keys(this.filter).forEach((item) => {
        if (item === "date") {
          const date = this.filter[item]
          if (date.length > 0 && date[0] !== null && date[1] !== null) {
            filter.date_start = date[0];
            filter.date_end = date[1];
          }
        } else if (item === "client_ids") {
          if (this.filter[item].length > 0){
            filter[item] = this.filter[item]
          }
        } else {
          if (this.filter[item] !== "" && this.filter[item] !== null && this.filter[item] !== undefined) {
            filter[item] = this.filter[item]
          }
        }
      })

      this.$http.v1.getSpecificationsList(filter, (response) => {
        if (response.data) {
          this.specification_list = response.data
        } else {
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    toggleFiltersState() {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>
.specification_list {
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (max-width: 750px) {
    overflow-y: scroll;
  }

  .main_filters {
    top: 20px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    height: 100%;

    & > * {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    @media (max-width: 750px) {
      flex-direction: column;
    }

    .buttons {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      @media (max-width: 750px) {
        width: 100%;
      }

      .btn {
        margin-bottom: 10px;
        padding: 0 10px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .filter {
      margin: 0;
    }

    .form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user {
        margin-bottom: 0;
        width: 100%;
      }

      .btn {
        width: 30%;
      }
    }

    .form_select {
      flex: 1;
      @media (max-width: 750px) {
        flex: inherit;
        width: 100%;
        margin-bottom: 10px;
      }

      .vue-treeselect {
        margin-bottom: 0;
      }

      .form-group {
        margin: 0;
      }

      .select {
        margin-bottom: 10px;
        width: 100%;

        &:last-child {
          margin-bottom: 0;
        }
      }

      @media (max-width: 750px) {
        margin-right: 0;
      }
    }
  }

  .response_table {
    flex: 10;
    padding-left: 0;
    padding-right: 0;

    table {
      height: calc(100% - 40px);
      overflow-x: hidden;

      th{
        font-size: 14px;
      }

      tbody {
        .online {
          color: #15ab00;
        }

        span {
          font-size: 22px;
        }
      }
    }

    .level {
      display: inline-block;
      width: 20px;
      height: 100%;
    }

    .w180 {
      max-width: 180px;
      width: 180px;
    }

    .w100 {
      max-width: 100px;
      width: 100px;
    }

    .w120 {
      max-width: 120px;
      width: 120px;
    }

    .w50 {
      max-width: 50px;
      width: 50px;
    }

    .has_child {
      background-color: #eee;
      font-weight: bold;
    }

    .name {
      text-align: center;
    }

    .inn {
      text-align: left;
    }
  }
}

@media (max-width: 1200px) {
  .specification_list {
    .response_table {
      .w180 {
        max-width: none;
        width: auto;
      }

      .w100 {
        max-width: none;
        width: auto;
      }
    }
  }
}

@media (max-width: 500px) {
  .header {
    .form {
      width: 100%;

      .filter {
        min-width: max-content;
        margin: 0 10px;
      }
    }

    .btn {
      b {
        display: none;
      }

      width: 20%;
      min-width: inherit;
    }

    .search_user {
      width: 80%;
    }
  }

}
</style>
